var utils = require('../../utils')
import AppHeader from '../AppHeader'
export default {
  name: 'shop-history-force-edit',
  created () {
    this.search()
  },
  data () {
    return {
      canValidate: true,
      userImage: null,
      uploadFlg: false,
      user_name: null,
      user: {
        user_name: null,
        user_name_furigana: null,
        user_firstname: null,
        user_firstname_furigana: null,
        user_sex: null,
        user_birthday_format: null,
        user_age: null,
      },
      localShopHistories: []
    }
  },
  computed: {
    userDetail: function() {
      return this.$store.getters.userDetail
    },
    shops: function() {
      return this.$store.getters.usershopDetail
    },
    shopHistories () {
      return this.$store.getters.shopHistoryDetail
    },
    businesstypes: function() {
      return this.$store.getters.userDetailBusinessTypes
    },
    validation: function() {
      var v = {}
      v.shop_id_before = []
      v.shop_id_after = []
      v.change_day = []
      v.shop_id_before_all = true
      v.shop_id_after_all = true
      v.change_day_all = true
      v.not_input = true // falseが未入力あり
      for (var index in this.localShopHistories) {
        var vb = (this.localShopHistories[index].shop_id_before || !this.canValidate) ? true : false
        v.shop_id_before.push(vb)
        v.shop_id_before_all &= vb

        var va = (this.localShopHistories[index].shop_id_after || !this.canValidate) ? true : false
        v.shop_id_after.push(va)
        v.shop_id_after_all &= va

        var vd = (this.localShopHistories[index].change_day || !this.canValidate) ? true : false
        v.change_day.push(vd)
        v.change_day_all &= vd

        v.not_input = v.shop_id_before_all & v.shop_id_after_all & v.change_day_all
      }
      return v
    },
    isValid () {
      if (!this.canValidate) {
        return true
      }
      var validation = this.validation
      return validation.not_input
    },
    notify () {
      return this.$store.getters.usertypeHistoryNotify
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var data = {}
      var self = this
      var callback = function () {
        self.user.user_name = self.userDetail.attributes['user-name']
        self.user.user_firstname = self.userDetail.attributes['user-firstname']
        self.user.user_name_furigana = self.userDetail.attributes['user-name-furigana']
        self.user.user_firstname_furigana = self.userDetail.attributes['user-firstname-furigana']
        self.user.user_sex = self.userDetail.attributes['sex']
        self.user.user_birthday_format = self.userDetail.attributes['user-birthday-format']
        self.user.user_age = self.userDetail.attributes['age-format']
        for (var index in self.shopHistories) {
          var shopHistory = {
            id: self.shopHistories[index].attributes['id'],
            user_id: self.shopHistories[index].attributes['user-id'],
            shop_id_before: self.shopHistories[index].attributes['shop-id-before'],
            shop_name_before: self.shopHistories[index].attributes['shop-name-before'],
            shop_id_after: self.shopHistories[index].attributes['shop-id-after'],
            shop_name_after: self.shopHistories[index].attributes['shop-name-after'],
            change_day: self.shopHistories[index].attributes['change-day'],
            pickerOptionsChangeDate: {
              disabledDate(time) {
                return time.getTime() > Date.now()
              }
            }
          }
          self.localShopHistories.push(shopHistory)
        }
        if(self.userDetail.attributes['user-avartar'] != null){
          self.userImage = self.userDetail.attributes['avartar-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp
        }
      }

      this.$store.dispatch('USER_DETAIL',  {id: this.$route.params.id, data: data, callback: callback})
    },
    checkChangeDate: function(event, index) {
      var value = event.target.value
      if (!this.isDate(value) || ((new Date(value)).getTime() > Date.now())) {
        this.localShopHistories[index].change_day = ''
        event.target.value = ''
      }
    },
    isDate: function(str) {
      if (!str) return false
      str = str.replace(/[^0-9]/g, '')
      if (str.length != 8 || isNaN(str)) return false
      var y = parseInt(str.substr(0,4))
      var m = parseInt(str.substr(4,2)) - 1
      var d = parseInt(str.substr(6,2))
      var dt = new Date(y, m, d)
      return (y == dt.getFullYear() && m == dt.getMonth() && d == dt.getDate())
    },
    setShopName: function (kind, index) {
      if (kind === 'before') {
        this.localShopHistories[index].shop_name_before = this.getShopName(this.localShopHistories[index].shop_id_before)
      } else if (kind === 'after') {
        this.localShopHistories[index].shop_name_after = this.getShopName(this.localShopHistories[index].shop_id_after)
      }
    },
    getShopName: function(id) {
      if (!id) return ''
      for (var index in this.shops) {
        if (this.shops[index].id == id) {
          return this.shops[index].attributes['shop-name']
        }
      }
      return ''
    },
    addHistory: function () {
      var shopHistory = {
        shop_id_before: '',
        shop_name_before: '',
        shop_id_after: '',
        shop_name_after: '',
        change_day: '',
        pickerOptionsChangeDate: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        }
      }
      this.localShopHistories.unshift(shopHistory)
    },
    deleteHistory: function (index) {
      this.localShopHistories.splice(index, 1)
    },
    sortHistory: function () {
      this.localShopHistories.sort(function(a, b) {
        if (!a.change_day) return -1
        if (!b.change_day) return 1
        var dateA = new Date(a.change_day), dateB = new Date(b.change_day);
        return dateB - dateA;
      });
    },
    setSaveDatas: function() {
      for (var index in this.localShopHistories) {
        // 店舗異動前名設定
        if (this.localShopHistories[index].shop_id_before) {
          this.localShopHistories[index].shop_name_before = this.getShopName(this.localShopHistories[index].shop_id_before)
        }
        // 店舗異動後名設定
        if (this.localShopHistories[index].shop_id_after) {
          this.localShopHistories[index].shop_name_after = this.getShopName(this.localShopHistories[index].shop_id_after)
        }
        // 異動日付型変更
        // Date型で送信するとlocaleがUTCになる場合があるので送信前に文字列型に統一する
        var change_day = this.localShopHistories[index].change_day
        if (change_day) {
          var obj = new Date(change_day)
          var yy = obj.getFullYear()
          var mm = obj.getMonth() + 1
          var dd = obj.getDate()
          this.localShopHistories[index].change_day = yy + '-' + mm + '-' + dd
        }
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/userhistory/' + this.$route.params.id })
    },
    onClickSave: function () {
      console.log('onClickSave')
      var data = {}
      var self = this
      self.canValidate = true
      if (this.isValid) {
        this.sortHistory()
        this.setSaveDatas()
        data.histories = self.localShopHistories
        data.user_id = self.$route.params.id
        this.$store.dispatch('SHOPHISTORY_ALL_UPDATE', { data: data, callback: this.onSaved, user_id: self.$route.params.id })
      } else {
        console.log("need edit");
      }
    },
    onSaved: function (result) {
      this.$router.push('/userhistory/' + this.$route.params.id)
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.userImage
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-history-force-edit.js